export default __webpack_public_path__ + "e097b71641f2524e09820d9122b7e910.ttf";